import { useMemo } from 'react';
import {
  DEFERRED_REQUEST_KEYS,
  type DeferredRequestKey
} from '~/constants/common/deferredRequests';
import { useResolvedOnServer } from '~/context/common/DeferredResolutionContext';
import { useConfiguration } from '~/context/common/StaticContext';

export type DeferredRequestState = {
  [key in DeferredRequestKey]: {
    configured: boolean;
    resolvedOnServer: boolean;
  };
};

export function useGetDeferredRequests() {
  const { DeferredRequestsConfig: { enabled, requests: requestsConfig } = {} } =
    useConfiguration();
  const resolvedOnServer = useResolvedOnServer();

  return useMemo(
    () => ({
      enabled,
      requests: DEFERRED_REQUEST_KEYS.reduce<DeferredRequestState>(
        (acc, key) => {
          acc[key] = {
            configured: requestsConfig?.[key] ?? false,
            resolvedOnServer: resolvedOnServer[key]
          };

          return acc;
        },
        {} as DeferredRequestState
      )
    }),
    [enabled, requestsConfig, resolvedOnServer]
  );
}
